import { BASE_ASSETS_URL } from "constants/app";
import { CALL_STATUS_TYPES, CALLER_TYPES, VIEW_MESSAGES, ERROR_MSGS, ACTIVE_STATE_TYPES } from "./constants";

export function getDerivedState(state) {
  const { userStatus, agentStatus, callStatus } = getStatus(state);
  const message = getStatusMessage(callStatus, state);
  const isActionButtonsShown = showActionButtons(callStatus);
  const duration = callStatus !== CALL_STATUS_TYPES.ENDED ? getCallDuration(state) : null;

  return {
    userStatus,
    agentStatus,
    callStatus,
    message,
    isActionButtonsShown,
    duration,
  };
}

export function getStatus(state) {
  const { callDetails, userNumber, agentNumber } = state;
  let userStatus = CALL_STATUS_TYPES.INITIATED;
  let agentStatus = CALL_STATUS_TYPES.INITIATED;
  let callStatus = CALL_STATUS_TYPES.INITIATED;

  if (callDetails) {
    userStatus = callDetails.metaData[userNumber];
    agentStatus = callDetails.metaData[agentNumber];

    if (userStatus === CALL_STATUS_TYPES.INITIATED && agentStatus === CALL_STATUS_TYPES.INITIATED) {
      callStatus = CALL_STATUS_TYPES.INITIATED;
    } else if (userStatus === CALL_STATUS_TYPES.ENDED && agentStatus === CALL_STATUS_TYPES.ENDED) {
      callStatus = CALL_STATUS_TYPES.ENDED;
    } else if (agentStatus === CALL_STATUS_TYPES.ANSWERED) {
      callStatus = `${CALLER_TYPES.USER}_${userStatus}`;
    } else if (agentStatus === CALL_STATUS_TYPES.ENDED && ![CALL_STATUS_TYPES.INITIATED, CALL_STATUS_TYPES.RINGING].includes(userStatus)) {
      callStatus = `${CALLER_TYPES.USER}_${userStatus}`;
    } else {
      callStatus = `${CALLER_TYPES.AGENT}_${agentStatus}`;
    }
  }

  return {
    userStatus,
    agentStatus,
    callStatus,
  };
}

export function getStatusMessage(status, state) {
  const { activeState, agentName = "",  callDetails, agentContactType } = state;
  const callerId = callDetails ? callDetails.callerId : "";
  const message = VIEW_MESSAGES[activeState][status];
  const agentFirstName = agentName.split(' ')[0];
  return message
        .replace(/<agentFirstName>/g, agentFirstName)
        .replace(/<agentName>/g, agentName)
        .replace(/<agentContactType>/g, agentContactType)
        .replace(/<callerId>/g, callerId);
}

export function showActionButtons(status) {
  status = status.replace(`${CALLER_TYPES.AGENT}_`, "").replace(`${CALLER_TYPES.USER}_`, "");
  return [CALL_STATUS_TYPES.ENDED, CALL_STATUS_TYPES.MISSED, CALL_STATUS_TYPES.REJECTED, CALL_STATUS_TYPES.NETWORK_ERROR, CALL_STATUS_TYPES.BUSY].includes(status);
}

export function getCallDuration(state) {
  const { callDetails } = state;
  if(!callDetails || !callDetails.callStartTime) return null;
  return callDetails.callDuration;
}

export function getStatusClassname(status) {
  switch(status) {
    case CALL_STATUS_TYPES.INITIATED: 
      return "initiated";
    case CALL_STATUS_TYPES.ANSWERED: 
      return "success";
    case CALL_STATUS_TYPES.MISSED:
    case CALL_STATUS_TYPES.REJECTED:
    case CALL_STATUS_TYPES.BUSY:
    case CALL_STATUS_TYPES.NETWORK_ERROR:
      return "error";
    case CALL_STATUS_TYPES.ENDED:
      return "ended";
    case CALL_STATUS_TYPES.RINGING:
        return "ringing";
    default: 
      return "initiated";
  }
}

export function isCallEnded(userStatus, agentStatus) {
  const endStates = [CALL_STATUS_TYPES.BUSY, CALL_STATUS_TYPES.MISSED, CALL_STATUS_TYPES.REJECTED, CALL_STATUS_TYPES.NETWORK_ERROR, CALL_STATUS_TYPES.ENDED];
  return endStates.includes(userStatus) || endStates.includes(agentStatus);
}

export function isCallConnected(userStatus, agentStatus) {
  return userStatus === CALL_STATUS_TYPES.ANSWERED && agentStatus === CALL_STATUS_TYPES.ANSWERED;
}

export function getPhoneImageUrl(agentStatus, userStatus, activeState) {
  let image = isCallEnded(agentStatus, userStatus) ? "phone-dismiss" : "phone-call";
  image = `${image}${activeState === ACTIVE_STATE_TYPES.CALL_MINIMIZED ? "-white" : ""}`
  return `${BASE_ASSETS_URL}images/${image}.svg`;
}

export function getPhoneImageClassName(agentStatus, userStatus) {
  if(isCallEnded(agentStatus, userStatus)) return "ended";
  if(isCallConnected(agentStatus, userStatus)) return "in_progress";
  return "";
}

export function getErrorMessages(state) {
  const { title = ERROR_MSGS.TITLE, message = ERROR_MSGS.MESSAGE } = state.error;
  return {
    title,
    message,
  };
}
